import OpeningHoursService from '../../lib/api/openinghours.service';
import LocationService from '../../lib/api/location.service';
import DeliveryService from '../../lib/api/delivery.service';

export async function fetchLocations({ commit }) {
  const response = await LocationService.getAll();

  if (response.status === 200) {
    commit('setLocations', response.data);
  }
}

export async function fetchDeliveryMethods({ commit }) {
  const response = await DeliveryService.getAll();

  if (response.status === 200) {
    commit('setDeliveryMethods', response.data);
  }
}

export async function fetchOpeningHours(context, { locationId }) {
  const response = await OpeningHoursService.get(locationId);

  if (response.status === 200) {
    return response.data;
  }

  return null;
}
